import PersonalIntroductionVideoForm from "@/app/(introduction-video)/_components/introduction-video/PersonalIntroductionVideoForm";
import { useModal } from "@/app/_components/share/Modal";
import NoDataSection from "@/app/_components/share/NoDataSection";
import { DEFAULT_PAGINATION } from "@/app/_components/share/Pagination";
import { toast } from "@/app/providers";
import {
  deleteIntroductionVideo,
  getPersonalIntroductionVideos,
} from "@/services/api/personal";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  HStack,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react";
import { get } from "lodash";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCirclePlus, FaTrash } from "react-icons/fa6";
import { useQuery } from "react-query";

export default function IntroductionVideoListSelectModal({
  selectedIds = [""],
  onSelect = () => {},
}) {
  const { t } = useTranslation();
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const { push } = useRouter();
  const [openModal, closeModal] = useModal();

  const { data, refetch = () => {} } = useQuery(
    ["getIntroductionVideoList", pagination],
    () => getPersonalIntroductionVideos({ page: pagination?.page, limit: 20 })
  );

  const [selectedVideoIds, setSelectedVideoIds] = useState(
    selectedIds.map((item) => item._id)
  );

  useEffect(() => {
    setPagination(data);
  }, [data]);

  if (!data) return null;

  const onClickAddMore = () => {
    openModal({
      title: t("Register New Intro Video"),
      body: (
        <PersonalIntroductionVideoForm
          isHideHeader={true}
          closeModal={() => {
            closeModal();
            refetch();
          }}
        />
      ),
      placement: "right",
      props: {
        size: "2xl",
      },
      isCompact: true,
    });
  };

  const onSelectedVideo = () => {
    const video = data.docs.filter((video) =>
      selectedVideoIds.includes(video._id)
    );
    onSelect(video);
  };

  const onDeleteVideo = async (id) => {
    await deleteIntroductionVideo(id);
    refetch();
    toast({
      title: t("Delete introduction video"),
      status: "success",
    });
  };

  return (
    <Stack gap={10}>
      <Stack gap={3}>
        <CheckboxGroup
          defaultValue={selectedVideoIds}
          onChange={(value) => setSelectedVideoIds(value)}
          maxH={get(data, "docs.length") === 0 ? "fit-content" : 40}
          overflow="auto"
        >
          {get(data, "docs.length") ? (
            data.docs.map((video) => (
              <Checkbox key={video.id} value={video._id} rounded="100%">
                <HStack justify="space-between" flexGrow={1} w="full">
                  <Text>{video.title}</Text>
                  <Text>{video.createdAt}</Text>
                  {selectedVideoIds.includes(video._id) ? (
                    <IconButton
                      h={6}
                      w="fit-content"
                      p={0}
                      variant="ghost"
                      icon={<FaTrash />}
                      onClick={() => onDeleteVideo(video._id)}
                    />
                  ) : (
                    ""
                  )}
                </HStack>
              </Checkbox>
            ))
          ) : (
            <NoDataSection
              description="Add video description"
              content={t("No introduction video yet")}
            />
          )}
        </CheckboxGroup>
        <Button
          py={0}
          pl={0}
          w="fit-content"
          color="secondary"
          variant="ghost"
          leftIcon={<FaCirclePlus />}
          onClick={onClickAddMore}
        >
          {t("Add more video")}
        </Button>
        {get(data, "docs.length") ? (
          <HStack justify="end">
            <Text>{t("Add video description")}</Text>
          </HStack>
        ) : null}
      </Stack>
      <Button onClick={onSelectedVideo} isDisabled={!selectedVideoIds}>
        {t("Share video cancel")}
      </Button>
    </Stack>
  );
}
